import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarVendor";
import Header from "components/Navbars/VendorNavbar";
import { AppointmentRoutes } from "views-vendors/AppointmentList";
import routesVendors from "routes-vendors";
import { useSelector, useDispatch } from "react-redux";
import { userSelector, exitGhostLoginAction } from "slices/userSlice";

function InterpreterLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();
  const dispatch = useDispatch();
  const { ghostAdminSession, user } = useSelector(userSelector);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleExitGhostLogin = () => {
    dispatch(exitGhostLoginAction((success) => {
      if (success) {
        window.location.href = "/vendors";
      }
    }));
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routesVendors}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        {ghostAdminSession && (
          <div style={{ backgroundColor: '#ffcccc', padding: '10px', textAlign: 'center', fontWeight: 'bold', color: '#cc0000', zIndex: 9999, position: 'relative' }}>
            You are currently ghost logged in as vendor {user?.name || ''}.
            <button onClick={handleExitGhostLogin} style={{ marginLeft: '15px', padding: '5px 10px', backgroundColor: '#cc0000', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
              Return to Admin
            </button>
          </div>
        )}
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {routesVendors.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default InterpreterLayout;
